import {
  VEND_PO_DOC_REPORT,
  VEND_PO_DOC_REPORT_SUCCESS,
  PO_DOC_PDF,
} from "./actionTypes";

const initialState = {
  PO_Doc_report: {},
  POPdf: false,

  reportType: "list",
  params: {
    // mrstatus: [0],
    // no_of_pages: 0,
    // page_size: 20,
    // page: 1,
    // search: "",
    // currentSort: "code",
    // sortOrder: "-",
  },
};

const VendorPO = (state = initialState, action) => {
  switch (action.type) {
    //

    case VEND_PO_DOC_REPORT:
      state = {
        ...state,
        loading: false,
      };
      break;
    case VEND_PO_DOC_REPORT_SUCCESS:
      state = {
        ...state,
        PO_Doc_report: action.payload,
        loading: false,
      };
      break;
    case PO_DOC_PDF:
      state = {
        ...state,
        POPdf: action.payload.POPdf,
        loading: false,
      };
      break;

    default:
      state = { ...state };
      break;
  }

  return state;
};
export default VendorPO;
